import { render, staticRenderFns } from "./AdminUserAdd.vue?vue&type=template&id=365c7e48&scoped=true"
import script from "./AdminUserAdd.vue?vue&type=script&lang=js"
export * from "./AdminUserAdd.vue?vue&type=script&lang=js"
import style0 from "./AdminUserAdd.vue?vue&type=style&index=0&id=365c7e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c7e48",
  null
  
)

export default component.exports